<template>
    <div class="email">
        <div class="title">邮箱</div>
        <input type="text" placeholder="请输入邮箱地址" v-model="email">
        <p class="error-message">{{errorMsg}}</p>
        <div class="submit-btn" @click="updateUserInfo('email',email)">确定</div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'Email',
    data(){
        return{
            email:'',
            errorMsg:'',
            reg:/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        }
	},
	created(){
		this.email=this.$route.params.email
	},
    methods:{
        updateUserInfo(infokey,infoValue){
            if(!this.reg.test(infoValue)){
                this.errorMsg="请输入正确邮箱地址"
            }else{
                let updateInfo={}
                updateInfo[infokey]=infoValue
                Axios.post('/user/update',updateInfo)
                .then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.$router.go(-1)
                        }
                    }
                ).catch(
                    error=>{
                        this.$swal({
							text:'网络错误 请稍后重试',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						})
                    }
                )
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .email{
        padding:40px 56px;
        padding-top:148px;
        .title{
            font-size:26px;
            color:#222;
            margin-bottom:30px;
            font-weight:bold;
        }
        input{
            width:612px;
            height:70px;
            background:#f7f7f7;
            border-radius:35px;
            border:none;
            color:#222;
            font-size:24px;
            padding-left:26px;
            padding-right:0 !important;
        }
        .error-message{
            margin-bottom:60px;
        }
        input::-webkit-input-placeholder{
            color:#ccc;
        }
        .submit-btn{
            width:638px;
            height:70px;
            line-height:70px;
            text-align:center;
            background:#bf0000;
            border-radius:35px;
            color:#fff;
            font-size:24px;
        }
        .submit-btn:active{
            background:#DD8080;
        }
    }
</style>